import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  InputAdornment,
  Divider,
} from "@mui/material";
import { LocalOffer } from "@mui/icons-material";

const PriceRangeFilter = ({ priceRange, onPriceRangeChange, formatPrice }) => {
  // Estado local para los inputs
  const [localMin, setLocalMin] = useState(
    priceRange[0] ? Math.round(priceRange[0] / 1000000).toString() : ""
  );
  const [localMax, setLocalMax] = useState(
    priceRange[1] && priceRange[1] !== Number.MAX_SAFE_INTEGER
      ? Math.round(priceRange[1] / 1000000).toString()
      : ""
  );

  // Actualizar el estado local si el prop cambia externamente
  useEffect(() => {
    setLocalMin(
      priceRange[0] ? Math.round(priceRange[0] / 1000000).toString() : ""
    );
    setLocalMax(
      priceRange[1] && priceRange[1] !== Number.MAX_SAFE_INTEGER
        ? Math.round(priceRange[1] / 1000000).toString()
        : ""
    );
  }, [priceRange]);

  // Actualizar el filtro global solo en Enter o blur
  const handlePriceChange = (min, max) => {
    const minValue = min ? parseInt(min) * 1000000 : 0;
    const maxValue = max ? parseInt(max) * 1000000 : Number.MAX_SAFE_INTEGER;
    onPriceRangeChange([minValue, maxValue]);
  };

  // Handlers de input
  const handleMinChange = (e) => {
    setLocalMin(e.target.value.replace(/[^\d]/g, ""));
  };
  const handleMaxChange = (e) => {
    setLocalMax(e.target.value.replace(/[^\d]/g, ""));
  };

  // Enter = actualizar inmediatamente
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handlePriceChange(localMin, localMax);
    }
  };

  // Blur = actualizar inmediatamente
  const handleBlur = () => {
    handlePriceChange(localMin, localMax);
  };

  return (
    <>
      <Box sx={{ mb: 3 }}>
        <Typography variant="subtitle2" fontWeight="bold" gutterBottom>
          <LocalOffer sx={{ fontSize: 16, mr: 0.5 }} />
          Rango de Precio
        </Typography>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <TextField
            size="small"
            label="Mínimo"
            placeholder="0"
            value={localMin}
            onChange={handleMinChange}
            onKeyDown={handleKeyPress}
            onBlur={handleBlur}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
              endAdornment: <InputAdornment position="end">M</InputAdornment>,
            }}
            sx={{ flex: 1 }}
            type="number"
            inputProps={{ min: 0, step: 1 }}
          />
          <Typography variant="body2" color="text.secondary">
            -
          </Typography>
          <TextField
            size="small"
            label="Máximo"
            placeholder="Sin límite"
            value={localMax}
            onChange={handleMaxChange}
            onKeyDown={handleKeyPress}
            onBlur={handleBlur}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">$</InputAdornment>
              ),
              endAdornment: <InputAdornment position="end">M</InputAdornment>,
            }}
            sx={{ flex: 1 }}
            type="number"
            inputProps={{ min: 0, step: 1 }}
          />
        </Box>
        {(priceRange[0] > 0 || priceRange[1] < Number.MAX_SAFE_INTEGER) && (
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ mt: 1, display: "block" }}
          >
            {priceRange[0] > 0 ? formatPrice(priceRange[0]) : "Sin mínimo"} -{" "}
            {priceRange[1] === Number.MAX_SAFE_INTEGER
              ? "Sin máximo"
              : formatPrice(priceRange[1])}
          </Typography>
        )}
      </Box>
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default PriceRangeFilter;
